import { jsx as _jsx } from "react/jsx-runtime";
import { Switch as HeroSwitch } from '@heroui/react';
export const Switch = (props) => {
    return _jsx(HeroSwitch, { ...props });
};
export default Switch;
//# sourceMappingURL=Switch.js.map